export const GET_CARGO_CATEGORIES = 'GET_CARGO_CATEGORIES';
export const GET_CARGO_CATEGORY = 'GET_CARGO_CATEGORY';
export const FLAG_GETTING_CARGO_CATEGORIES = 'FLAG_GETTING_CARGO_CATEGORIES';
export const FLAG_CARGO_CATEGORY_ACTIVITY = 'FLAG_CARGO_CATEGORY_ACTIVITY';
export const CLEAR_CARGO_CATEGORY = 'CLEAR_CARGO_CATEGORY';
export const CLEAR_CARGO_CATEGORIES = 'CLEAR_CARGO_CATEGORIES';
